import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SearchHeaderComponent } from "./search-header.component";
import { SimpleSelectModule } from "libraries/module/formbuilder/fields/simple-select/simple-select.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { DateModule } from "../../../../../libraries/module/formbuilder/fields/date/date.module";
import { LocalizedModule } from "libraries/pipes/localized/localized.module";
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";

@NgModule({
    imports: [
        CommonModule,
        SimpleSelectModule,
        BtnModule,
        DateModule,
        LocalizedModule,
        MultiselectModule,
    ],
    declarations: [
        SearchHeaderComponent,
    ],
    exports: [
        SearchHeaderComponent,

    ],
    providers: []
})
export class SearchHeaderModule {

}
